import FAQ from "../featured/faq";
import search from "../../assets/search.svg"
import "./style.css";

const FAQs = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center w-100">
      <div className="d-flex justify-content-center w-100 faq-ask-bg">
        <div className="section-container d-flex justify-content-center">
          <div className="faq-ask  ">
            <div className="d-flex align-items-center flex-column">
              <div className="faq-title off-black bold ">
                Frequently Asked Questions
              </div>
              <div
                className="large off-black normal text-center"
                style={{ opacity: "0.6", marginTop: "0.625rem" }}
              >
                Straight answers to the most common labeling, audit, and insight
                queries.
              </div>
            </div>
            {/* <div className="position-relative">
              <input
                className="search-box input input-pre"
                placeholder="Search for a question"
              />
              <div className="input-pre-icon">
                <img src={search} alt="search" style={{ width: "1.25rem" }} />
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="section-container d-flex justify-content-center ">
        <FAQ />
      </div>
    </div>
  );
};

export default FAQs;
